import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPinWorld = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20 31C18.042 29.417 17.917 24.208 21 23C22.636 22.359 23.166 25.937 26.375 25.042C26.996 24.869 28.458 25.75 27.926 27.094",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.294 12.787C14.925 13.253 15.418 13.858 15.883 14.636C16.288 15.315 17.189 17.206 16.364 18.274C15.43 19.48 12.727 19.887 12.727 21C12.727 21.837 13.912 22.793 14.545 23.727C15.497 25.132 15.064 26.494 14.545 27.363C14.276 27.814 13.818 28.174 13.342 28.46",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.8 19C29.931 19.646 30 20.315 30 21C30 26.523 25.523 31 20 31C14.477 31 10 26.523 10 21C10 15.477 14.477 11 20 11C20.494 11 20.98 11.036 21.455 11.105",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29 13C29 15.469 25 19 25 19C25 19 21 15.469 21 13C21 10.469 23.067 9 25 9C26.933 9 29 10.469 29 13Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgPinWorld);
export default ForwardRef;
